import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOMeta from "@/components/SEOMeta";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Home, Wrench, Zap, Droplet, Wind } from "lucide-react";

const NiagaraFalls = () => {
  const services = [
    { title: "Decks & Fences", icon: Home, link: "/services/deck-fence" },
    { title: "Framing Services", icon: Wrench, link: "/services/framing" },
    { title: "Bathroom Remodeling", icon: Droplet, link: "/services/bathroom-renovations" },
    { title: "Kitchen Renovation", icon: Home, link: "/services/kitchen-renovations" },
    { title: "General Contracting", icon: Wrench, link: "/services/general-contracting" },
    { title: "Renovations", icon: Home, link: "/services/renovations" }
  ];

  return (
    <>
      <SEOMeta 
        title="General Contractor in Niagara Falls — Residential & Commercial"
        description="Construction and renovation services in Niagara Falls. Full-service trades: carpentry, electrical, plumbing, HVAC, roofing, masonry and more."
        keywords="general contractor Niagara Falls, Niagara Falls construction, renovation contractor, decks, framing, bathroom remodel, kitchen renovation"
        canonicalUrl="https://blueknightcontracting.ca/niagara-falls"
      />
      
      <LocalBusinessSchema 
        locationName="Niagara Falls"
        addressLocality="Niagara Falls"
        addressRegion="ON"
        postalCode="L2E"
        description="Construction and renovation services in Niagara Falls. Full-service trades including carpentry, electrical, plumbing, HVAC, roofing, masonry and complete contracting services."
        services={[
          "General Contracting",
          "Renovation Services",
          "Kitchen Renovations",
          "Bathroom Remodeling",
          "Deck Construction",
          "Framing Services"
        ]}
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        
        <section className="relative bg-gradient-to-br from-primary to-primary/80 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl lg:text-6xl font-bold mb-6">
                General Contractor in Niagara Falls
              </h1>
              <p className="text-xl mb-8 opacity-90">
                Construction and renovation services in Niagara Falls. Full-service trades: carpentry, electrical, plumbing, HVAC, roofing, masonry and more.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" variant="secondary">
                  <Link to="/contact">Get Free Quote</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
                  <Link to="/services">View All Services</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Our Services in Niagara Falls
              </h2>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                Professional construction and renovation services for Niagara Falls homes and businesses
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <Card key={index} className="h-full hover:shadow-lg transition-shadow">
                  <CardHeader>
                    <service.icon className="h-12 w-12 text-primary mb-4" />
                    <CardTitle>{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Button asChild variant="link" className="px-0">
                      <Link to={service.link}>Learn More →</Link>
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-primary text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Need a Contractor in Niagara Falls?
            </h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Contact Blue Knight Contracting for professional construction services in Niagara Falls. Licensed, insured and locally trusted.
            </p>
            <Button asChild size="lg" variant="secondary">
              <Link to="/contact">Get Free Quote Today</Link>
            </Button>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default NiagaraFalls;
